module.exports = __webpack_public_path__ + "static/stageSet7-d3910cb9558773894b0c7297b1f37e27.jpg";